import React from 'react';
interface Props {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
export function ChartPanel({
  title,
  subtitle,
  action,
  children,
  className = ''
}: Props) {
  return <section className={`card p-4 ${className}`} data-id="element-62" data-mp="3uwg9qifoql50">
      <div className="mb-3 flex items-start justify-between gap-2" data-id="element-63" data-mp="3pxmx0s882y5w">
        <div data-id="element-64" data-mp="3pwbtmtiovsfb">
          <h3 className="text-sm font-bold text-ink" data-id="element-65" data-mp="328aozvomsw56">{title}</h3>
          {subtitle && <p className="text-xs text-ink-muted" data-id="element-66" data-mp="326hcw0v91jps">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>;
}
export const CHART = {
  navy: '#0B4778',
  green: '#008451',
  sky: '#9CC3E0',
  warning: '#E7A12A',
  danger: '#D64545',
  grid: '#E6EDF3',
  tick: {
    fontSize: 11,
    fill: '#526375',
    fontFamily: 'Hind Siliguri'
  },
  tooltip: {
    fontFamily: 'Hind Siliguri',
    fontSize: 12,
    borderRadius: 8,
    border: '1px solid #DDE6EE'
  }
};